var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/category";
export class CategoryApi extends RestService {
    getAll(params, active) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(URL, Object.assign(Object.assign({}, params), { active }));
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    getOne(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/${categoryId}`);
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    create(category) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, category, this.headers.multipart);
            return res.ok;
        });
    }
    update(category) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, category, this.headers.multipart);
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
    updateActivity(ids, newStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/activity`, { ids, newStatus });
            return res.ok;
        });
    }
}
//# sourceMappingURL=CategoryApi.js.map